import { useEffect, useState } from "react"
import { useReferenceState } from "lib/@hooks/use-reference"

export function useTableQuery({ sortKey, pageSizeKey, defaultPageSize = 10, defaultSort = null, refreshKey }) {
    const [take, setTake] = useReferenceState(pageSizeKey, defaultPageSize)
    const [sort, setSort] = useReferenceState(sortKey, defaultSort)
    const [skip, setSkip] = useState(0)

    useEffect(resetToFirstPage, [sort, take, refreshKey])

    return { skip, take, sort, page: Math.floor(skip / take) + 1, setTake, setPage, toggleSort }

    function resetToFirstPage() {
        setSkip(0)
    }

    function setPage(nextPage) {
        setSkip((nextPage - 1) * take)
    }

    function toggleSort(field) {
        setSort(nextSort)

        function nextSort(current) {
            if (current?.field !== field) return { field, descending: false }
            if (!current.descending) return { field, descending: true }
            return defaultSort ?? null
        }
    }
}
